<template>
  <el-dialog title="发放套餐" width="500" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="设备sn号" :label-width="formLabelWidth">
        <el-input v-model="form.deviceSn" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="套餐" :label-width="formLabelWidth">
        <el-select v-model="formData.packageId" clearable placeholder="-请选择套餐-" style="width: 100%;">
          <el-option v-for="(item,index) in list" :key="index" :label="item.packageName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生效时间" :label-width="formLabelWidth">
        <el-date-picker
              v-model="formData.startTime"
              style="width: 100%;"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
            >
            </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import WifiApi from '@/api/wifi.js'

  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        list:[],
        formData:{
          packageId:'',
          startTime:''
        }
      };
    },
    props: ['show_grant', 'form'],
    created() {
      this.dialogVisible = this.show_grant;
      this.getList()
    },
    methods: {

      getList() {
            const params = {
                pageSize: 100,
                pageIndex: 1
            }
            WifiApi.packageList({ ...params }).then(res => {
                this.list  = res.data.records
            }).catch(e => {
            })
        },

      submit() {
        let self = this;
        if(!self.formData.packageId){
          self.$message({
                message: '请选择套餐',
                type: 'warning'
              });
              return
        }
        if(!self.formData.startTime){
          self.$message({
                message: '请选择生效时间',
                type: 'warning'
              });
              return
        }
        self.loading = true;
        let params = {
          "deviceId": self.form.id,
    "deviceSn": self.form.deviceSn,
    "packageId": self.formData.packageId,
    "startTime": self.formData.startTime
        }
        WifiApi.deviceGrantPackage(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ybwifi/device/dialog/GrantPackage.vue